/**
 * "Latest request wins." Pages load data in effects keyed on (org, id); when
 * the user switches org or record mid-flight, the OLDER response can land after
 * the newer one and overwrite fresh state with stale data. A gate hands every
 * load a token; only the most recent, un-cancelled token may write state.
 */
export interface LatestGate {
  /** Start a load; returns its token. Supersedes every earlier token. */
  begin(): number;
  /** Whether `token` is still the newest live load. */
  isCurrent(token: number): boolean;
  /** Invalidate every outstanding token (unmount / dependency change). */
  cancel(): void;
}

export function createLatestGate(): LatestGate {
  let seq = 0;
  return {
    begin: () => ++seq,
    isCurrent: (token) => token === seq,
    cancel: () => {
      seq += 1;
    },
  };
}
